export default __webpack_public_path__ + "static/media/convalida-bg.acbfe961.png";